import { render, staticRenderFns } from "./PlacementResultTestTable.vue?vue&type=template&id=39ac20aa"
import script from "./PlacementResultTestTable.vue?vue&type=script&lang=js"
export * from "./PlacementResultTestTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports